<ngx-table-control-panel [allowDensityChange]="config?.allowDensityChange"
                         [defaultDensity]="config?.defaultDensity"
                         (densityChanged)="onDensityChanged($event)"></ngx-table-control-panel>
<div class="ngx-responsive-table"
     [ngClass]="tableDensity"
     [class.freeze-first-column]="config?.medium?.isFreezeFirstColumn">
    <div class="table-wrapper">
        <ng-content select="table"></ng-content>
    </div>
</div>
